import React, {Component} from 'react';
import {getFormationByID, getRegisteredSponsorsForFormationID} from "../../../../services/formationsService"
import {Redirect, withRouter} from 'react-router-dom';
import LoadingComponent from "../../common/loadingComponent";
import FormationForm from "./FormationForm";
import httpService from "../../../../services/httpService";

class LoadFormationForm extends Component {

    _isMounted = false;

    state = {
        RedirectToLoginPage:false,
        isLoading : false,
        userToken : this.props.user,
        formation : {},
        registeredSponsors : {},
        locale : this.props.locale
    };


    componentDidMount() {
        this._isMounted = true;

        if (this.props.id !== undefined){
            this.onLoadFormation();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onLoadFormation = async () =>{
        try {
            this.setState({isLoading:true});
            const [ {data: formation},
                    {data : registeredSponsors}] =
                    await httpService.all(
                        [   getFormationByID(this.props.id),
                                  getRegisteredSponsorsForFormationID(this.props.id)]
                    );

            if (this._isMounted){
                this.setState({
                    formation,
                    registeredSponsors,
                    isLoading: false
                });
            }

        }  catch(err)  {
            if (this._isMounted){
                this.setState({isLoading: false, RedirectToLoginPage:true});
            }
        }
    }


    renderPage = () => {
        return (
          <>
              <FormationForm
                  isAdminForm = {(this.props.id)?true:false}
                  locale = {this.props.locale}
                  formation = {this.state.formation}
                  registeredSponsors = {this.state.registeredSponsors}
              />
          </>
        );
    }

    render() {

        if (this.state.RedirectToLoginPage) {
            const loginPage = `/${this.state.locale}/login`
            return <Redirect to={loginPage}  />
        }

        return (
            <>
                {this.state.isLoading ? <LoadingComponent/> : this.renderPage()}
            </>
        );
    }
}

export default withRouter(LoadFormationForm);
